import * as React from "react";
import { Datagrid, ExportButton, TextField, TopToolbar } from "react-admin";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { CustomDateField } from "../../../Components/CustomDateField";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const CockpitSvcUnsvcPnDifferenceViewList = props => {
  const ListActions = props => (
    <TopToolbar>
      <ExportButton {...props} maxResults={99999} />
    </TopToolbar>
  );

  const exporter = records => {
    const data = records.map(record => ({
      RefNo: record.refNo,
      Customer: record.customer,
      "Svc Pn": record.svcPn,
      "Core Pn": record.unsvcPn,
      "Created Date": record.createdDate,
    }));

    const columns = Object.keys(data[0]).map(record => ({ header: record }));

    ExcelExport(columns, data, "Svc Pn & Core Pn Difference List");
  };

  return (
    <PoolList
      {...props}
      filterDefaultValues={props.filterParams}
      perPage={10}
      actions={<ListActions />}
      exporter={exporter}
      bulkActionButtons={false}
      filter={{ isDifferent: true }}
    >
      <Datagrid>
        <TextField source="refNo" label={"Ref No"}/>
        <TextField source="customer" label={"Customer"}/>
        <TextField source="svcPn" label={"Svc Pn"}/>
        <TextField source="unsvcPn" label={"Core PN"}/>
        <CustomDateField source="createdDate" label={"Created Date"}/>
      </Datagrid>
    </PoolList>
  );
};

export default CockpitSvcUnsvcPnDifferenceViewList;
